import { config } from "@/config";

import { useQuery } from "@tanstack/react-query";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export interface Category {
  _id: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  name: string;
  description: string | null;
  parent: string | null;
  path: string;
  metadata: { icon: string } | null;
  ancestors: string[];
  children: Category[];
  level?: number;
  shapeCount: number;
}

export default function useGetCategoriesService(
  enabled?: boolean,
  format?: string
) {
  const { getAuthHeaders } = useAuthHeaders();
  const getCategoriesFlat = async (
    format?: string
  ): Promise<{ data: Category[] }> => {
    let url = `${config.isometricApiUrl}/categories`;
    if (format) {
      url = url + `?format=${format}`;
    }
    try {
      const response = await apiFetch(url, {
        headers: getAuthHeaders(),
      });

      // Check if the response is ok (status code in the range 200-299)
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json(); // Parse the JSON response
    } catch (error) {
      console.error("Error:", error); // Handle errors
      return { data: [] };
    }
  };

  return useQuery({
    queryKey: [format ? "categories-nested" : "categories"],
    queryFn: () => {
      return getCategoriesFlat(format);
    },
    enabled: !!enabled,
  });
}
